<template>
  <div class="modal_wrap system speed_popup_modal" :class="{ on: show }">
    <div class="modal_inner">
      <div class="modal">
        <div class="modal_head">
          <h1 class="h1">소진 시 데이터 속도</h1>
        </div>
        <div class="modal_con">
          <div class="modal_txt">
            <ul>
              <li v-for="(item, index) in speedTxt" :key="index">
                <div class="txt_1">{{ item.title }}</div>
                <div class="txt_2">{{ item.content }}</div>
              </li>
            </ul>
          </div>
        </div>
        <div class="modal_btn">
          <div class="btn_wrap">
            <button class="btn" @click="close()">
              확인
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StorageFactory from '@common/lib/common/storage';

export default {
  props: {
    show: Boolean,
    data: {
      type: Object,
    },
  },
  data() {
    return {
      speedTxt: [
        {
          title: '1Mbps 미만',
          content: '카톡 텍스트는 원활! 사진전송은 느려요.',
        },
        { title: '1Mbps', content: '3G 보다 조금 느린 정도에요.' },
        { title: '3Mbps', content: '영상을 720p 화질로 볼 수 있어요.' },
        {
          title: '5Mbps',
          content: '영상을 1080p 화질로 볼 수 있어요.',
        },
        {
          title: '10Mbps',
          content: '영상을 고화질로 끊김 없이 볼 수 있어요.',
        },
      ],
    };
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>
